// extracted by mini-css-extract-plugin
module.exports = {"toast":"TorToast_toast__262PN","toastError":"TorToast_toastError__1P41B","toastSuccess":"TorToast_toastSuccess__ax1fP"};